import Vue from 'vue'
import App from './App.vue'
import router from './router';
import request from '../common/request.js';
import api from '../common/api.js';
import utils from '../common/utils.js';

import dialog from "./components/dialog/index.vue";
import blogCard from "./components/blog-card/index.vue";
import select2 from "./components/select2/index.vue";
import tagSelector from "./components/tag-select/index.vue";
import commentList from "./components/comment-list/index.vue";

Vue.config.productionTip = false

Vue.prototype.$request = request;
Vue.prototype.API = api;
Vue.prototype.$utils = utils;
// 引入markdown插件
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
// use
Vue.use(mavonEditor)


// 引入富文本编辑器
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
Vue.component("Editor", Editor);
Vue.component("Toolbar", Toolbar);

//自定义组件
Vue.component("popup", dialog);
Vue.component("blogCard", blogCard);
Vue.component("select2", select2);
Vue.component("tagSelector", tagSelector);
Vue.component("commentList", commentList);



new Vue({
    render: h => h(App),
    router,
}).$mount('#app')